import PropTypes from 'prop-types';

const ButtonContainer = ({ children, width = '100%', containerWidth = '100%', align = 'center', alignText = 'left' }) => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: align,
            width: containerWidth,
            textAlign: alignText
        }}>
            <div style={{ width }}>{children}</div>
        </div>
    );
};

ButtonContainer.propTypes = {
    children: PropTypes.element.isRequired,
    width: PropTypes.string,
    containerWidth: PropTypes.string,
    align: PropTypes.string,
    alignText: PropTypes.string
};

export default ButtonContainer;
